export const typography = {
  fontFamily: 'Inter',
  stat1: {
    fontSize: 60,
    fontWeight: 600,
    letterSpacing: -0.5,
    textAlign: 'left',
  },
};
